import { Injectable } from '@angular/core';
import { tap, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReCaptcha } from '../recaptcha/model/ReCaptcha';
import { AppConfig } from './../../core/config/app.config';
import { AppConfigConstants } from './../../core/config/app.config.constants';

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {

  constructor(private http: HttpClient) { }

  valdateReCaptcha(reCaptcha: ReCaptcha): Observable<boolean> {

    const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
    AppConfigConstants.RECAPTCHA_URL_SEGMENT]).concat('/validate');
    return this.http.post(url, reCaptcha)
      .pipe(
        map((data: boolean) => data)
      );
  }
}
